export default "__VITE_PUBLIC_ASSET__236cd27f__"